module.exports = __webpack_public_path__ + "static/naslovna-biografija-c16bad2d2ccec3012c36cca92dc8a166.jpg";